// src/services/appService.js
import appConfig from '../config';
import { validateToken, executeModule } from './apiLabsService';

// App selection
export const getCurrentApp = () => {
  return appConfig.getCurrentApp();
};

export const getAppId = () => {
  return appConfig.getAppIdFromPath();
};

// Token handling
export const getToken = () => {
  return localStorage.getItem('apiLabzToken');
};

export const saveToken = (token) => {
  localStorage.setItem('apiLabzToken', token);
};

export const removeToken = () => {
  localStorage.removeItem('apiLabzToken');
};

// API operations
export const checkToken = async (token) => {
  return await validateToken(token);
};

export const processQuery = async (token, inputValues) => {
  const appId = getAppId();
  
  // If inputValues is a string (for backwards compatibility), 
  // convert it to an object with the app's bodyKey
  let processedValues = inputValues;
  
  if (typeof inputValues === 'string') {
    const app = appConfig.getCurrentApp();
    processedValues = { [app.bodyKey]: inputValues };
  }
  
  return await executeModule(token, appId, processedValues);
};